import { Button, Collapse, ListItemText, styled } from '@mui/material';
import { alpha } from '@mui/system';
import { Link } from 'react-router-dom';

const StyledListItemXs = styled('li')(({ theme }) => ({
  color: theme.palette.common.white,
  cursor: 'pointer',
  padding: theme.spacing(2),
  
  '&>svg': {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textTransform: 'capitalize',
  display: 'flex',
  '& .MuiTypography-body1': {
    fontWeight: 700,
    color: theme.palette.common.white,
  },
}));

const StyledListItemWithLink = styled('li')(({ theme }) => ({
  cursor: 'pointer',
  padding: 0,

  '&.active': {
    boxShadow: `inset 3px 0px 0 0px ${theme.palette.common.white}`
  },

  display: 'none',

  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
}));

const StyledItemLink = styled(Button)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  cursor: 'pointer',
  padding: theme.spacing(2),
  borderRadius: 0,
  '&:hover': {
    backgroundColor: theme.palette.primary['500'],
  },
}));

const StyledListItem = styled('li')(({ theme }) => ({
  color: theme.palette.common.white,
  cursor: 'pointer',
  padding: theme.spacing(2),

  // Arrow
  '&>svg': {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

const StyledCollapse = styled(Collapse)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary['500'] ?? theme.palette.primary.main, 0.2),

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const StyledSubItem = styled('li')(({ theme }) => ({
  borderRadius: 0,
  padding: 0,
  margin: 0,
  '& .MuiListItemIcon-root': {
    minWidth: theme.spacing(5),
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary[200],
  },
  '&.Mui-selected .MuiTypography-root': {
    fontWeight: '700',
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    cursor: 'pointer',
  },
}));

const StyledSubItemLink = styled(Link)(({ theme }) => ({
  borderRadius: 0,
  padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  paddingLeft: theme.spacing(4),
  textTransform: 'capitalize',
  position: 'relative',
  cursor: 'pointer !important',
  width: '100%',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export {
  StyledCollapse, StyledItemLink,
  StyledListItem, StyledListItemText,
  StyledListItemWithLink, StyledListItemXs, StyledSubItem,
  StyledSubItemLink
};

